import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Dialog } from 'day8-ui';
import { LoadingView, userActions } from 'day8-react';
import Konami from 'react-konami';
import Login from './Login';
import Signup from './Signup';
import ForgotPassword from './ForgotPassword';
import RequiredUserDetails from './RequiredUserDetails';
import { validateUser } from '../../actions/user';

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forceOpen: this.props.location?.state?.forceOpen || false
    };
  }
  componentDidMount() {
    this.setState({ forceOpen: this.props.location?.state?.forceOpen });
  }
  async componentDidUpdate(prevProps) {
    const { location, validateUser, user } = this.props;
    const isOpen = location?.state?.showLoginModal;
    const shouldValidateUser = location?.state?.shouldValidateUser;
    const isForceOpen = location?.state?.forceOpen;
    // if modal has been opened and location state forceOpen value has changed then reset state here too
    if (isForceOpen !== prevProps.location?.state?.forceOpen && isOpen) {
      this.setState({ forceOpen: location?.state?.forceOpen });
    }
    // if modal has been opened and user is logged in and should validate user than validate...
    if (location?.state?.showLoginModal !== prevProps.location?.state?.showLoginModal && isOpen && shouldValidateUser && user) {
      await validateUser();
    }
  }

  onClose() {
    const { location, history, dispatch } = this.props;
    const forceOpen = this.state.forceOpen;
    if (forceOpen) {
      return;
    }
    history.replace({
      pathname: location.pathname,
      search: location.search,
      state: {
        ...location.state,
        showLoginModal: false
      }
    });
    // Clear required details
    dispatch({
      type: 'VALIDATE_USER',
      requiredDetails: [],
      onSuccess: null
    });
  }

  getModalTitle() {
    const {
      location, user, requiredDetails
    } = this.props;

    if (user && location.state && location.state.page === 'edit' || requiredDetails?.length) {
      return 'Edit Details';
    }
    if (user && location.state && location.state.returnTo) {
      return `Hey ${user.firstName},`;
    }
    if (location.state && location.state.page === 'login') {
      return 'Log in';
    }
    if (location.state && location.state.page === 'signup') {
      return 'Sign up';
    }
    if (location.state && location.state.page === 'reset') {
      return 'Reset password';
    }
    return '';
  }

  renderPage(page = 'login') {
    const {
      location, user, requiredDetails, fetching, history
    } = this.props;

    if (fetching) {
      return <LoadingView />;
    }

    if (user && page === 'edit' || requiredDetails?.length) {
      return (
        <RequiredUserDetails location={location} />
      );
    }

    if (user && location.state && location.state.returnTo) {
      return history.push(location.state.returnTo);
    }

    if (page === 'login') {
      return (
        <Login
          location={location}
          signupTo={{ state: { ...location.state, page: 'signup' }, search: location.search }}
          resetTo={{ state: { ...location.state, page: 'reset' }, search: location.search }}
          shouldValidateUser={location.state.shouldValidateUser}
        />
      );
    }
    if (page === 'signup') {
      return (
        <Signup
          location={location}
          loginTo={{ state: { ...location.state, page: 'login' }, search: location.search }}
          shouldValidateUser={location.state.shouldValidateUser}
        />
      );
    }
    if (page === 'reset') {
      return (
        <ForgotPassword
          location={location}
          loginTo={{ state: { ...location.state, page: 'login' }, search: location.search }}
        />
      );
    }
    return null;
  }
  render() {
    const { location } = this.props;
    const isOpen = location.state && location.state.showLoginModal;
    if (!isOpen) {
      return null;
    }
    return (
      <React.Fragment>
        <Dialog
          open={isOpen}
          onOpenChange={() => this.onClose()}
          title={(
            <>
              <h2 className='dui-text-xl dui-mb-4'>{this.getModalTitle()}</h2>
              {location.state.description && <p className='dui-mb-4'>{location.state.description}</p>}
            </>
          )}
          scrollable
        >
          <Konami
            easterEgg={() => this.setState({ forceOpen: false })}
            konami={[79, 80, 69, 78, 83, 69, 83, 65, 77, 69]}
          />
          {this.renderPage(location.state.page)}
        </Dialog>
      </React.Fragment>
    );
  }
}

LoginModal.propTypes = {
  user: PropTypes.object,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  logoutUser: PropTypes.func.isRequired,
  requiredDetails: PropTypes.array,
  fetching: PropTypes.bool,
  dispatch: PropTypes.func,
  validateUser: PropTypes.func
};

const mapStateToProps = store => ({
  user: store.user.loggedUser,
  requiredDetails: store.user.requiredDetails,
  fetching: store.user.fetching
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logoutUser: userActions.logoutUser,
      validateUser,
      dispatch
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginModal);
